export default __webpack_public_path__ + "static/media/lung3.db402350.jpg";